<template>
    <div style="height: 100%;">
        <FormaPagamentoList v-show="!rotaAninhada" :reloadData="reloadData" />
        <router-view />
    </div>
</template>

<script>
import FormaPagamentoList from '@/components/despesas/forma-pagamento/FormaPagamentoList.vue';

export default {
    name: 'DesFormaPagamentoListRoute',

    beforeRouteUpdate(to, from, next) {
        this.rotaAninhada = to.name != 'des-forma-pagamento-list';
        if (from.name != 'des-forma-pagamento-list' && to.name == 'des-forma-pagamento-list') {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 300);
        }
        next();
    },
    components: {
        FormaPagamentoList,
    },
    data() {
        return {
            rotaAninhada: false,
            reloadData: false,
        };
    },
    created() {
        this.rotaAninhada =
            this.$route.name.includes('des-forma-pagamento') &&
            this.$route.name != 'des-forma-pagamento-list';
    },
};
</script>
